(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-toggle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('content-toggle')) {
    class ContentToggle extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const btn = event.target.closest('[data-ct-tab]');
          if (!btn) return;
          this._activate(btn.dataset.ctTab);
        });
      }

      _activate(index) {
        this.querySelectorAll('[data-ct-tab]').forEach((btn) => {
          const active = btn.dataset.ctTab === index;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active);
        });
        this.querySelectorAll('[data-ct-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.ctPanel !== index;
        });
      }
    }
    customElements.define('content-toggle', ContentToggle);
  }

  } catch(e) { console.error(e); }
})();
})();
